import { connect } from 'react-redux';
import { isVideoDialEnabledSelector } from '../../../../../../store/redux/selectors/videoDialEnabledSelector';
import ConceptRotationOptions from './ConceptRotationOptions';

export default connect(isVideoDialEnabledSelector)(ConceptRotationOptions);
